<h3 style="text-align: center; margin: 5vh; ">An e-mail has been sent to the address you provided. Please click the attached link to verify your account.</h3>
<div style="display: flex; align-items: center; justify-content: center; margin-top: -20px">
  <button mat-raised-button (click)="goToLogin()">Done</button>
</div>